module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('notification-standard', {
    staticClass: "notification-behavioral",
    attrs: {
      "item": _vm.item
    },
    on: {
      "notification:targeted": _vm.triggerTarget,
      "notification:deleted": _vm.triggerDelete
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title")], 2), _vm._v(" "), _vm._t("", [(_vm.item.targeted) ? _c('div', {
    staticClass: "notification-body"
  }, [_vm._t("body"), _vm._v(" "), (_vm.behaviorShown) ? _c('div', {
    staticClass: "notification-behavior-container"
  }, [(_vm.hasBehaviors) ? _c('div', {
    ref: "behaviorContainer",
    domProps: {
      "innerHTML": _vm._s(_vm.behaviorContent)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("behaviors")], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item.targeted) ? _c('div', {
    staticClass: "notification-footer"
  }, [_vm._t("footer", [_c('div', {
    staticClass: "behaviors-container",
    staticStyle: {
      "display": "flex",
      "overflow": "hidden"
    }
  }, _vm._l((_vm.behaviors), function(b) {
    return _c('div', {
      staticClass: "behavior text-center",
      staticStyle: {
        "flex": "1 1 auto"
      }
    }, [_c('span', {
      staticClass: "behavior-btn btn",
      class: _vm.getBehaviorButtonClass(b.name),
      attrs: {
        "title": b.title
      },
      on: {
        "click": function($event) {
          _vm.loadBehavior(b)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon",
      class: b.icon
    }), _vm._v("\n                            " + _vm._s(b.label) + "\n                        ")])])
  }))])], 2) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-148311ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/behaviors/Behavioral.vue
// module id = 1085
// module chunks = 0